import { Car02 } from "@untitledui/icons";
import { format, parse } from "date-fns";
import { Fragment } from "react";
import type { Program } from "../../state/api.types";
import { formatCents, formatCurrency } from "../../utilities/currency";
import { ViewOnlyField } from "./ViewOnlyField";

type EditProgramProps = {
  program: Program;
};

const formatTime = (time: string) => {
  const date = parse(time, "HH:mm", new Date());
  return format(date, date.getMinutes() === 0 ? "ha" : "h:mma").toLowerCase();
};

export const EditProgram = ({ program }: EditProgramProps) => {
  const ev = program.ev_charging_details;
  if (!ev) return null;

  const schedules = ev.schedules ?? [];
  const primaryRate = (ev.on_schedule_rates ?? []).at(0);

  return (
    <div className="flex flex-col gap-2xl">
      <div className="flex flex-col gap-sm">
        <div className="flex w-full flex-row items-center gap-md">
          <Car02 />
          <div
            className="w-full truncate text-lg font-semibold"
            title={`${program.name} Program`}
          >
            {program.name} Program
          </div>
        </div>
        <div className="text-sm text-tertiary">
          Lower bills for EV owners with off-peak charging.
        </div>
      </div>
      <div className="flex flex-wrap gap-3xl">
        {schedules.length > 0 && (
          <ViewOnlyField
            className="min-w-[100px] flex-1"
            label="Schedule"
            value={schedules.map((schedule, index) => (
              <Fragment key={index}>
                {index > 0 && <br />}
                {formatTime(schedule.start_time)} –{" "}
                {formatTime(schedule.end_time)}
              </Fragment>
            ))}
          />
        )}
        {primaryRate && (
          <ViewOnlyField
            className="min-w-[100px] flex-1"
            label="Charging rate"
            value={
              <>
                {formatCents(primaryRate.rate)}¢ per kWh,
                <br />
                incl. delivery fees
              </>
            }
          />
        )}
        {ev.base_fee && (
          <ViewOnlyField
            className="min-w-[100px] flex-1"
            label="Charging fee"
            value={formatCurrency(ev.base_fee)}
          />
        )}
      </div>
    </div>
  );
};
